import { RouteComponent, useRouter } from 'react-resource-router';

import { useAppData } from 'src/app/data';
import HistoryWatcher from 'src/components/performance-metrics/history-watcher';
import { RouteContext, ROUTE_NAME } from 'src/router/routes/types';
import { getRouteFeaturesFromAppData } from 'src/router/utils/route-features';

export const UniversalRoutes = () => {
  const [routerState] = useRouter();
  const { route } = routerState as RouteContext;
  const appData = useAppData();
  const { isNavigationRestructureEnabled } =
    getRouteFeaturesFromAppData(appData);

  if (
    // The root route "/" is a redirect, so we don't want to render any additional components yet
    route.name === ROUTE_NAME.ROOT
  ) {
    return <RouteComponent />;
  }

  // The layout is rendered above universal routes when the isNavigationRestructureEnabled feature is enabled
  const Wrapper = isNavigationRestructureEnabled ? undefined : route.layout;

  return (
    <>
      <HistoryWatcher />
      {Wrapper ? (
        <Wrapper>
          <RouteComponent />
        </Wrapper>
      ) : (
        <RouteComponent />
      )}
    </>
  );
};
